import { useEffect, forwardRef, useState, useRef, useImperativeHandle} from "react";
import { AudioMatePlayer, parsePlayAudio} from  "../../../ApiCenter/AudioMatePlayer";

const buttonViewWidth = 90;
const buttonDetailsIconWidth = 40;
export const FileManagerToolBar = forwardRef((props, ref) => {

    const findExplorerRef = useRef();

    const defaultSettings = {
        flatView: true,
        detailsView: true,
        spinner: false
    }

    const [fileManagerSettings, setFileManagerSettings] = useState(defaultSettings)

    useImperativeHandle(ref, () => ({
        refreshToolBar(props){
            setFileManagerSettings(prev => {
                return {
                    ...prev,
                    [props.key]: props.value
                }
            })
        },
        playAudio(props){
            parsePlayAudio(props)
        },
        spinner(props){
            setFileManagerSettings(prev => {
                return {
                    ...prev,
                    spinner: props
                }
            })
        },
        resultsFromFind(results, findValue){
            findExplorerRef.current.resultsFromFind(results, findValue)
        }
    }))

    const detailsViewSwitcher = () => {

        props.messageFromToolbar({type: 'detailsView', value: !fileManagerSettings.detailsView})
        setFileManagerSettings(prev => {
            return {
                ...prev,
                detailsView: !fileManagerSettings.detailsView
            }
        })
    }

    useEffect(() => {
        const handleRefreshToolBar = (event) => {
            if(event.detail.type === 'flatView'){
                setFileManagerSettings(prev => {
                    return {
                        ...prev,
                        flatView: event.detail.value
                    }
                })
            }
        }
        window.addEventListener('refreshToolBar', handleRefreshToolBar)
        return () => {
            window.removeEventListener('refreshToolBar', handleRefreshToolBar)
        }
    }, [])


    return <div className="mb-1">
                <div className="btn-group">
                    <button 
                        className={`btn btn-${fileManagerSettings.flatView ? 'primary' : 'outline-primary'} btn-sm`} 
                        style={{width: buttonViewWidth}}
                        title="Shows uploaded assets in a unique list"
                        onClick={() => fileManagerSettings.flatView === false ? props.messageFromToolbar({type: 'flatView', value: true}) : null}>
                            Flat
                    </button>

                    <button 
                        className={`btn btn-${!fileManagerSettings.flatView ? 'primary' : 'outline-primary'} btn-sm`} 
                        style={{width: buttonViewWidth}}
                        title="Shows uploaded assets in original structure"
                        onClick={() => fileManagerSettings.flatView === true ? props.messageFromToolbar({type: 'flatView', value: false}) : null}>
                        Structured    
                    </button>
                </div>
                <div className="btn-group ms-2">
                    <button 
                        className={`btn btn-${fileManagerSettings.detailsView ? 'primary' : 'outline-primary'} btn-sm`} 
                        style={{width: buttonDetailsIconWidth}}
                        onClick={fileManagerSettings.detailsView  ? null : detailsViewSwitcher}>
                            <i className="bi bi-list"></i>
                    </button>

                    <button 
                            className={`btn btn-${!fileManagerSettings.detailsView ? 'primary' : 'outline-primary'} btn-sm`} 
                            style={{width: buttonDetailsIconWidth}}
                            onClick={!fileManagerSettings.detailsView  ? null : detailsViewSwitcher}>
                            <i className="bi bi-grid-fill"></i>    
                    </button>
                </div>
                {fileManagerSettings.spinner && 
                    <div className="btn-group ms-3">
                        <div className="spinner-border text-primary" role="status" style={{width: '20px', height: '20px'}}>
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                }
                <FindInExplorer ref={findExplorerRef} handleFind={props.handleFind} goto={props.goto} clearFind={props.clearFind} />
                <AudioMatePlayer markers={false} updateMarkers={null} />
            </div>

});

const FindInExplorer = forwardRef((props, ref) => {

    const defaultState = {
        disableButton: true,
        value: '',
        startFind: false,
        results: [],
        openOperation: false
    }
    const [findSettings, setFindSettings] = useState(defaultState);

    useImperativeHandle(ref, () => ({
        resultsFromFind(results, searchValue){
            setFindSettings(prev => ({
                ...prev,
                startFind: false,
                openOperation: true,
                results: results, 
            }))
            if(results.length > 0){
                props.goto({ item: results[0], searchValue: searchValue })
            }
        }
    }))

    const setSearchTermHandler = (value) => {

        setFindSettings(prev => ({
            ...prev,
            disableButton: value.trim().length < 3,
            value: value
        }));
    }

    const startFind = () => {
        setFindSettings(prev => ({
            ...prev,
            startFind: true
        }));
        props.handleFind(findSettings.value)
    }

    const clearSearch = () => {
        setFindSettings(defaultState);
        props.clearFind();
    }

    return <><div className="btn-group btn-group-sm ms-2">
                <input style={{width: '130px'}} 
                        type="text" 
                        className="form-control form-control-sm" 
                        placeholder="Find" 
                        value={findSettings.value} onChange={(e) => setSearchTermHandler(e.target.value)} />
                <button 
                    disabled={findSettings.disableButton}
                    onClick={startFind}
                    className="btn btn-primary btn-sm">
                        Find
                </button>
            </div>
            {findSettings.openOperation && <div style={{display: 'inline-block'}}>
                <span className="ms-2">{findSettings.results.length} results</span>

                <i onClick={clearSearch}
                    style={{color: 'red'}}
                    title="Clear search" className="bi bi-x-lg ms-2"></i>

            </div>}
            </>

})